module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione6.1a2a65b8.svg";